import {
  createSlice,
  PayloadAction,
  createDraftSafeSelector
} from '@reduxjs/toolkit';
import { useSelector, connect, useDispatch } from 'react-redux';
import { RootState } from 'store';
import storage from 'libs/storage';
import getQueryString from 'libs/getQueryString';
import { useCallback, useEffect } from 'react';
import { get } from 'lodash';

// const companyID = storage.getCompanyId();
const wutianCompanyID = '102';

const themeColor = '#5774ff';
const subThemeColor = 'rgba(87, 116, 255, 0.1)';
const bubbleLeftBGColor = "#f5f5f5";
const bubbleLeftTextColor = "#333333";
const bubbleRightBGColor = "#5774ff";
const bubbleRightTextColor = '#fff';

const wutianThemeColor = '#FF0000';
const wutianSubThemeColor = 'rgba(255, 0, 0, 0.08)';
const wutianBubbleLeftBGColor = '#E0E0E0';
const wutianBubbleLeftTextColor = '#333';
const wutianBubbleRightBGColor = '#f2f2f2';
const wutianBubbleRightTextColor = '#333';

interface IInitialState {
  variable: any;
  isWutian: boolean;
}

const initialState: IInitialState = {
  variable: {
    themeColor: themeColor,
    subThemeColor: subThemeColor,
    bubbleLeftBGColor: bubbleLeftBGColor,
    bubbleLeftTextColor: bubbleLeftTextColor,
    bubbleRightBGColor: bubbleRightBGColor,
    bubbleRightTextColor: bubbleRightTextColor,
  },
  isWutian: false,
  // variable: {
  //   themeColor: companyID === wutianCompanyID ? wutianThemeColor : themeColor,
  //   subThemeColor:
  //     companyID === wutianCompanyID ? wutianSubThemeColor : subThemeColor,
  //   bubbleLeftBGColor:
  //     companyID === wutianCompanyID
  //       ? wutianBubbleLeftBGColor
  //       : bubbleLeftBGColor,
  //   bubbleLeftTextColor:
  //     companyID === wutianCompanyID
  //       ? wutianBubbleLeftTextColor
  //       : bubbleLeftTextColor,
  //   bubbleRightBGColor:
  //     companyID === wutianCompanyID
  //       ? wutianBubbleRightBGColor
  //       : bubbleRightBGColor,
  //   bubbleRightTextColor:
  //     companyID === wutianCompanyID
  //       ? wutianBubbleRightTextColor
  //       : bubbleRightTextColor
  // }
};

export const themeSlice = createSlice({
  name: "theme",
  initialState: initialState,
  reducers: {
    setVariable: (state, action: PayloadAction<any>) => {
      const next = action.payload || {};
      state.variable = { ...state.variable, ...next };
    },
    setIsWutian: (state, action: PayloadAction<any>) => {
      if (typeof action.payload === "boolean") {
        state.isWutian = action.payload;
      }
    },
  },
});

export const mapVariable = (state: RootState) => state.theme.variable;
export const mapThemeColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.themeColor
);
export const mapSubThemeColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.subThemeColor
);
export const mapBubbleLeftBGColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.bubbleLeftBGColor
);
export const mapBubbleLeftTextColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.bubbleLeftTextColor
);
export const mapBubbleRightBGColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.bubbleRightBGColor
);
export const mapBubbleRightTextColor = createDraftSafeSelector(
  mapVariable,
  variable => variable.bubbleRightTextColor
);
export const mapIsWutian = (state: RootState) => state.theme.isWutian;
export const { setVariable, setIsWutian } = themeSlice.actions;

export const useAutoSetThemeColor = () => {
  const themeColor = useSelector(mapThemeColor);
  const subThemeColor = useSelector(mapSubThemeColor);
  const bubbleLeftBGColor = useSelector(mapBubbleLeftBGColor);
  const bubbleLeftTextColor = useSelector(mapBubbleLeftTextColor);
  const bubbleRightBGColor = useSelector(mapBubbleRightBGColor);
  const bubbleRightTextColor = useSelector(mapBubbleRightTextColor);
  const dispatch = useDispatch();

  const updateCSSVariable = useCallback(() => {
    document.documentElement.style.setProperty('--theme-color', themeColor);
    document.documentElement.style.setProperty(
      '--subtheme-color',
      subThemeColor
    );
    document.documentElement.style.setProperty(
      '--bubble-left-bg-color',
      bubbleLeftBGColor
    );
    document.documentElement.style.setProperty(
      '--bubble-left-text-color',
      bubbleLeftTextColor
    );
    document.documentElement.style.setProperty(
      '--bubble-right-bg-color',
      bubbleRightBGColor
    );
    document.documentElement.style.setProperty(
      '--bubble-right-text-color',
      bubbleRightTextColor
    );
  }, [
    themeColor,
    subThemeColor,
    bubbleLeftBGColor,
    bubbleLeftTextColor,
    bubbleRightBGColor,
    bubbleRightTextColor
  ]);

  useEffect(() => {
    updateCSSVariable();
  }, [
    updateCSSVariable,
    themeColor,
    subThemeColor,
    bubbleLeftBGColor,
    bubbleLeftTextColor,
    bubbleRightBGColor,
    bubbleRightTextColor
  ]);

  useEffect(() => {
    const localCompanyID = storage.getCompanyID();
    const urlCompanyID = getQueryString('companyID');
    const companyID = urlCompanyID || localCompanyID;
    if (companyID === wutianCompanyID) {
      dispatch(setVariable({ themeColor: wutianThemeColor }));
      dispatch(setVariable({ subThemeColor: wutianSubThemeColor }));
      dispatch(setVariable({ bubbleLeftBGColor: wutianBubbleLeftBGColor }));
      dispatch(setVariable({ bubbleLeftTextColor: wutianBubbleLeftTextColor }));
      dispatch(setVariable({ bubbleRightBGColor: wutianBubbleRightBGColor }));
      dispatch(
        setVariable({ bubbleRightTextColor: wutianBubbleRightTextColor })
      );
      dispatch(setIsWutian(true));
    }
  }, [dispatch]);
};

export const useThemeColor = () => {
  return useSelector(mapThemeColor);
};

export const useThemeColorWithClass = (Compo: any) =>
  connect(state => {
    return {
      themeColor: get(state, `theme.variable.themeColor`)
    };
  })(Compo);

export default themeSlice.reducer;
